export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/illustrative.4407c62.svg";